import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withFirebase } from '../Firebase';
import Spinner from '../Spinner';

class UserItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    const { firebase, match, onSetUser, user } = this.props;
    if (!user) {
      this.setState({ loading: true });
    }

    firebase.user(match.params.id).on('value', (snapshot) => {
      onSetUser(snapshot.val(), match.params.id);

      this.setState({ loading: false });
    });
  }

  componentWillUnmount() {
    const { firebase, match } = this.props;
    firebase.user(match.params.id).off();
  }

  onSendPasswordResetEmail = () => {
    const { firebase, user } = this.props;
    firebase.doPasswordReset(user.email);
  };

  render() {
    const { match, user } = this.props;
    const { loading } = this.state;

    return (
      <div>
        <h2>User ({match.params.id})</h2>
        {loading && <Spinner loading={loading} />}

        {user && (
          <div>
            <span>
              <strong>ID:</strong> {user.uid}
            </span>
            <span>
              <strong>E-Mail:</strong> {user.email}
            </span>
            <span>
              <strong>Username:</strong> {user.username}
            </span>
            <span>
              <button type="button" onClick={this.onSendPasswordResetEmail}>
                Send Password Reset
              </button>
            </span>
          </div>
        )}
      </div>
    );
  }
}

UserItem.propTypes = {
  firebase: PropTypes.shape({
    user: PropTypes.func.isRequired,
    doPasswordReset: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onSetUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    uid: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, props) => ({
  user: (state.userState.users || {})[props.match.params.id],
});

const mapDispatchToProps = (dispatch) => ({
  onSetUser: (user, uid) => dispatch({ type: 'USER_SET', user, uid }),
});

export default compose(withFirebase, connect(mapStateToProps, mapDispatchToProps))(UserItem);
